// NoData.js
import React from 'react';
import { Package, Receipt } from 'lucide-react';

import { EmptyState } from '../Common/EmptyState';

/**
 * Legacy empty-state wrapper, kept because eleven pages call it.
 *
 * It used to render a 6rem green FontAwesome box above 1.5rem green text,
 * which looked nothing like the empty states on the newer pages. It now
 * delegates to the shared EmptyState, so every list in the app agrees on what
 * "nothing here yet" looks like — without having to touch the call sites.
 *
 * `message` is usually a full sentence ("Det finns inga kunder att visa. Skapa
 * en för att kunna se dem här."), so it lands in the description slot rather
 * than the title.
 *
 * New code should use EmptyState directly: it distinguishes first-run from
 * no-matches and takes an icon, title and action buttons.
 */
export const NoData = ({ message, icon = Package, title }) => (
    <EmptyState icon={icon} title={title} description={message} />
);

export const NoDataSupplierInvoice = ({ message, title }) => (
    <EmptyState icon={Receipt} title={title} description={message} />
);

export default { NoDataSupplierInvoice, NoData };
